export default {
  name: 'Media Property',
  sections: [
    {
      name: 'Property Information',
      fields: [
        {
          name: 'Name',
          type: 'text',
          target: 'name',
          rules: 'required|min:3|max:255',
          description: 'Enter property name.',
          edit: false,
        },
        {
          name: 'Type',
          type: 'text',
          target: 'type',
          rules: 'required|min:3|max:255',
          description: 'Enter property type.',
          edit: false,
        },
        {
          name: 'Group Name',
          type: 'text',
          target: 'group_name',
          rules: '',
          description: 'Enter property group name.',
        },
        {
          name: 'Logo',
          type: 'image',
          target: 'logo',
          file: 'file',
          path: 'path',
          accept: '.png',
          description:
            'Media Property Logo',
        },
      ],
    },
  ],
}
